import React from "react";

export type UseEventHandlerArgs = {
  deps?: React.DependencyList;
  name: string;
  handler: (event: any) => void;
};

export function useEventHandler(args: {
  deps?: React.DependencyList;
  name: string;
  handler: (event: any) => void;
}) {
  React.useEffect(() => {
    window.addEventListener(args?.name, args?.handler);
    return () => {
      window.removeEventListener(args?.name, args?.handler);
    };
  }, args?.deps || []);
}
